<template lang="pug">
draggable.uploads(@end="endHandler")
  .upload(
    v-for="(image, $index) in images"
    :key="image.id"
  )
    a.upload-delete.button.is-primary.is-small(@click="confirmDelete($index)")
      b-icon(icon="close")
    cloudinary-image(
      :cl-id="image.cl_id"
      :transform="{ width: 172, height: 172, crop: 'thumb' }"
    )
</template>

<script>
import Draggable from 'vuedraggable';
import CloudinaryImage from '@/components/CloudinaryImage';

export default {
  name: 'gallery-uploads',
  components: {
    Draggable,
    CloudinaryImage,
  },
  computed: {
    images() {
      return this.value;
    },
  },
  methods: {
    confirmDelete(index) {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this image cannot be undone.',
        confirmText: 'Yes, Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.$emit('delete', index),
      });
    },
    endHandler($event) {
      this.$emit('sort', {
        from: $event.oldIndex,
        to: $event.newIndex,
      });
    },
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss">
.uploads {
  display: flex;
  margin: 0.75rem 0;
  .upload {
    width: 86px;
    height: 86px;
    position: relative;
    background-color: $grey-lighter;
    & + .upload {
      margin-left: 0.75rem;
    }
    .image {
      cursor: move;
    }
    .upload-delete {
      position: absolute;
      right: 0;
      z-index: 1;
      color: $white;
      // text-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GalleryUploads.vue